/**
 * Lists root screen for the Address Book modal.
 * Equivalent to ContactListingCategories but for use inside the modal.
 */

import React from 'react';
import {
  IonPage,
  IonHeader,
  IonToolbar,
  IonTitle,
  IonButtons,
  IonButton,
  IonContent,
  IonItem,
  IonLabel,
  IonNote,
  IonIcon,
} from '@ionic/react';
import { closeOutline } from 'ionicons/icons';
import { useIonRouter, useIonViewWillLeave } from '@ionic/react';
import { useContactState } from './ContactStateContext';
import {
  selectAllContacts,
  selectAllListingCategories,
  selectContactsByListingCategory,
} from './reducer';
import SectionCard from '@/components/SectionCard';

const ContactLists: React.FC = () => {
  const router = useIonRouter();
  const { state } = useContactState();

  useIonViewWillLeave(() => {
    if (document.activeElement instanceof HTMLElement) {
      document.activeElement.blur();
    }
  });
  const contacts = selectAllContacts(state);
  const allListingCategories = selectAllListingCategories(state);

  return (
    <IonPage data-testid="address-book-lists-view">
      <IonHeader>
        <IonToolbar>
          <IonButtons slot="start">
            <IonButton
              fill="clear"
              color="medium"
              onClick={() => router.goBack()}
              aria-label="Close"
            >
              <IonIcon slot="icon-only" icon={closeOutline} />
            </IonButton>
          </IonButtons>
          <IonTitle>Lists</IonTitle>
        </IonToolbar>
      </IonHeader>
      <IonContent
        fullscreen
        style={{ '--background': 'var(--app-page-background)' }}
        data-testid="contact-lists-page"
      >
        <div style={{ padding: '16px' }}>
          <SectionCard
            noBottomMargin
            listProps={{ 'data-testid': 'lists-list' }}
          >
            <IonItem
              button
              detail
              onClick={() =>
                router.push('/ab/lists/all/contacts', 'forward', 'push')
              }
              data-testid="all-contacts-row"
            >
              <IonLabel>All Contacts</IonLabel>
              <IonNote slot="end">{contacts.length}</IonNote>
            </IonItem>

            {allListingCategories.map(category => {
              const count = selectContactsByListingCategory(
                state,
                category
              ).length;
              return (
                <IonItem
                  key={category}
                  button
                  detail
                  onClick={() =>
                    router.push(
                      '/ab/lists/' + encodeURIComponent(category) + '/contacts',
                      'forward',
                      'push'
                    )
                  }
                  data-testid={`list-category-row-${category}`}
                >
                  <IonLabel>{category}</IonLabel>
                  <IonNote slot="end">{count}</IonNote>
                </IonItem>
              );
            })}
          </SectionCard>
        </div>
      </IonContent>
    </IonPage>
  );
};

export default ContactLists;
